const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Aakarsh Garg</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Associate VFX Head, UPES-CSI</li>
    <li>
        Specializing in visual effects and creative content.
    </li>
    <li>
        Creating stunning visuals for events and campaigns.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
